import React from "react";
import i18n from "i18next";
import { withRouter } from "react-router-dom";

import { api } from "@/utils/api";
import LPMain from "@/react-components/LPMain";
import ConfirmButton from "@/react-components/Confirm/Button";
import ConfirmMain from "@/react-components/Confirm/Main";
import url from "@/utils/url";

class LPAgreementSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      contentText: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getPublishProtocal()
      .then((response) => {
        this.setState({
          title: response[0].noLoginTitle,
          contentText: response[0].contentText,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  back = () => {
    const {
      history: { replace },
    } = this.props;
    replace(url.lp);
  };

  render() {
    const { contentText, title } = this.state;
    return (
      <LPMain className="lp-agreement-container">
        <div className="lp-agreement-container-title">{title}</div>
        <div className="lp-agreement-container-content">
          <ConfirmMain content={contentText} />
          <ConfirmButton
            className="lp-agreement-container-content-button"
            onClick={this.back}
            text={i18n.t("common_back_home_button_title")}
          />
        </div>
      </LPMain>
    );
  }
}

export default withRouter(LPAgreementSection);
